import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import App from './App.vue';
import router from './router';
import './styles/main.css';

// Configure dayjs with UTC and timezone plugins
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Main entry point for Vue.js application
 */
const app = createApp(App);

// Register Pinia for state management
const pinia = createPinia();
app.use(pinia);

// Register Vue Router
app.use(router);

// Register Ant Design Vue
app.use(Antd);

// Mount app
app.mount('#app');